import api from "./api";

export const processAiSecurityResult = async ({
    shipmentId,
    ipAddress,
    hasAnomaly,
}) => {
    const res = await api.post("/adaptivesecurityorchestration/process-ai-result", {
        shipmentId: Number(shipmentId),
        ipAddress,
        hasAnomaly: Boolean(hasAnomaly),
    });

    return res.data;
};

export default {
    processAiSecurityResult,
};